import { Boolean, Record, Static, String } from 'runtypes';

export const DocumentListExtrasRunType = Record({
	category: String,
	documentBoxId: String,
	documentMayBeDeleted: Boolean,
	format: String,
	shouldShowTheClaimButton: Boolean,
	version: String,
});

export type DocumentListExtras = Static<typeof DocumentListExtrasRunType>;
